import {
  createSlice,
  PayloadAction,
  createAsyncThunk,
  createDraftSafeSelector,
  createSelector,
} from "@reduxjs/toolkit";
import { RootState } from "store";
import { get, trim } from "lodash";
import moment from "moment";
import storage from "libs/storage";
import chatService from "services/chat";
import {
  MessageType,
  ServerMessage,
  Messages,
  ClientMessage,
  Questions,
  MessageFrom,
  LoginFlow,
  ChatMode,
  IMenu,
  Conversation,
  IMEventTye,
} from "types/chat";
import {
  getBot,
  getUserInfo,
  getLoginFlow,
  mapLoginInfo,
  logout,
  setLoginInfo,
  resetLoginInfo,
} from "store/reducers/user";
import { isLogin } from "store/reducers/login";
import { setNoticeDetail } from "store/reducers/notice";
import { compose } from "redux";
import { setFormModalData } from "store/reducers/form";

import { StatusCode } from "libs/http/constant";
import { Modal, message } from "antd";
import {
  setAddressBook,
  ADDRESSBOOKTYPE,
  setAssignTutorItem,
} from "store/reducers/addressBook";
import IMService from "services/im";
import AuthService from "services/auth";
import history from "libs/history";
import uuid from "libs/uuid";
import getQueryString from "libs/getQueryString";
import getFilePrefix from "libs/getFilePrefix";

import { setFormModalVisible } from "store/reducers/form";
import { setTaskModalVisible } from "store/reducers/task";
import { setProfileVisible } from "store/reducers/profile";
import {
  setKnowledgeQuery,
  setKnowledgeVisible,
} from "store/reducers/knowledge";
import store from "store";
import { setScoreData, setScoreVisible } from "store/reducers/score";
import { closeAllModal } from "store/reducers/modalAll";
import TIM from "tim-js-sdk-ws";

const antdMessage = message;

const section_list_key = "section_list";
const im_history_list_key = 'im_history_list';
const im_button_list_key = "im_button_list";
const im_notice_list_key = "im_notice_list";
const im_event_list_key = "event_list";

let im: any = null;
export const inputPlaceholder = "我想问...";
export const inputMaxLength = 140;
class OnceCallbacks {
  callbacks: any[] = [];

  push = (fn: () => void) => {
    typeof fn === "function" && this.callbacks.push(fn);
  };

  execute = async () => {
    while (this.callbacks.length > 0) {
      const fn = this.callbacks.shift();
      await fn();
    }
    this.callbacks = [];
  };
}
const chatPageFinishedCallbacks = new OnceCallbacks();

export const loginWelcomePage = [
  generateTimeMessage(),
  {
    id: uuid(),
    from: MessageFrom.BOT,
    time: moment().valueOf(),
    messages: [
      {
        type: MessageType.text,
        data: {
          content: "你好，我是你的企业服务小助手，我可以解答你的日常问题。",
        },
      },
      {
        type: MessageType.client_agreement,
        data: {},
      },
    ],
  },
];

interface IInitialState {
  menu: IMenu;
  scrollToBottomTrigger: number;
  inputFocusTrigger: number;
  mode: ChatMode;
  inputValue: string;
  messages: Messages;
  historyMessages?: Messages;
  questions: Questions;
  hasBotLoadingMessage: boolean;
  sending: boolean;
  IMLoading: boolean;
  IMReady: boolean;
  IMMessages: Messages;
  IMSending: boolean;
  conversation: Conversation;
  streamFinish?: 0 | 1;
  responseType?: 0 | 1
}

const initialState: IInitialState = {
  menu: {
    knowledge_base: {
      name: "",
      skills: [],
    },
    workbench: {
      name: "",
      workbench_sub_groups: [],
    },
    show: false,
  },
  scrollToBottomTrigger: 0,
  inputFocusTrigger: 0,

  mode: ChatMode.BOT,
  inputValue: "",
  messages: [],
  historyMessages: [],
  sending: false,
  questions: [],
  hasBotLoadingMessage: false,

  IMLoading: false,
  IMReady: false,
  IMMessages: [],
  IMSending: false,
  conversation: {
    task_id: "",
    to_user_name: "",
    to_user_avatar: "",
    to_user_id: "",
    from_user_id: "",
    finish: false,
    ex_msgs: [],
    msgs: [],
    buttons: [],
    prologues: [],
    end_of_non_operation: {
      end_remind_msg: "",
      time: 0,
      enable: false,
    },
    conversation_id: "",
    read_status_visible: false,
  },
  /** 流式消息结束   */
  streamFinish: 1,
  /** 回答类型 1 大模型回答 0 标准问回答 */
  responseType: 0
};

export const getMenuList = createAsyncThunk(
  "chat/getMenuList",
  async (arg: any, thunkAPI) => {
    try {
      const res = await chatService.getSkillList();
      const success = get(res, "code") === StatusCode.success;
      const result = get(res, "result");
      if (success) {
        return result;
      }
    } catch (e) {
      console.log(e);
    }
  }
);

export const getHome = createAsyncThunk(
  "chat/getHome",
  async (arg: any, thunkAPI) => {
    try {
      const dispatch = thunkAPI.dispatch;
      const res = await chatService.getHome();
      get(res, "code") === StatusCode.success &&
        dispatch(setMessages([generateTimeMessage()]));
      const success = get(res, "code") === StatusCode.success;
      const result = get(res, "result");
      if (success && !isLoginMode()) {
        dispatch(flatMessages({ result }));
      }
    } catch (e) {
      console.log(e);
    }
  }
);

//获取历史文本信息
export const getHistoryTextMsg = createAsyncThunk(
  'chat/getHistoryTextMsg',
  async (arg: any, thunkAPI) => {
    try {
      const dispatch = thunkAPI.dispatch;
      // @ts-ignore
      const res = await chatService.getChatHistory();
      // dispatch(setHistoryMessages([generateTimeMessage()]));
      const success = get(res, 'code') === StatusCode.success;
      const result = get(res, 'result');
      if (success && isLogin()) {
        dispatch(flatHistoryeMessages({ result }));
      }
    } catch (e) {
      console.log(e);
    }
  }
);

export const initLoginPage = createAsyncThunk(
  "chat/initLoginPage",
  async (arg: any, thunkAPI) => {
    try {
      const dispatch = thunkAPI.dispatch;
      dispatch(cleanIM({}));
      dispatch(setChatMode(ChatMode.LOGIN));

      const preLoginPhone = storage.getPhone();
      const preCompanyId = storage.getCompanyID();
      const companyId = getQueryString("companyId");
      const logined = isLogin();

      if (logined && preCompanyId && companyId && preCompanyId !== companyId) {
        logout();
        window.location.reload();
      } else if (logined) {
        history.push("/chat");
      } else {
        storage.setPhone("");
        storage.setCompanyID("");
        storage.setToken("");
        await dispatch(getBot({}));
        dispatch(resetLoginInfo());
        dispatch(setLoginInfo({ companyId }));
        dispatch(setMessages(loginWelcomePage));
        preLoginPhone && dispatch(handleInputChange(preLoginPhone));
      }
    } catch (e) {
      console.log("login error: ", e);
    }
  }
);

export const initChatPage = createAsyncThunk(
  "chat/initChatPage",
  async (arg: any, thunkAPI) => {
    try {
      const dispatch = thunkAPI.dispatch;
      dispatch(cleanIM({}));
      setMessages([]);
      dispatch(setChatMode(ChatMode.BOT));

      await Promise.all([
        dispatch(getBot({})),
        dispatch(getUserInfo({})),
        dispatch(getHome({})),
      ]);

      chatPageFinishedCallbacks.execute();
    } catch (e) {
      console.log(e);
    }
  }
);

const generateSingleMessage = (payload: string | Partial<ServerMessage>) => {
  const isStr = typeof payload === "string";
  const isObj = Object.getPrototypeOf(payload)?.constructor === Object;
  if (isStr) {
    return {
      type: MessageType.text,
      data: {
        content: payload,
      },
      clientTimeStamp: moment().valueOf(),
    };
  } else if (isObj) {
    return {
      type: MessageType.text,
      clientTimeStamp: moment().valueOf(),
      ...(payload as any),
    };
  }
};

type MessageMaterial = string | ServerMessage | (ServerMessage | string)[];

type GenerateClientMessageArg = Partial<ClientMessage> & {
  payload: MessageMaterial;
};
interface GenerateClientMessageFn {
  (arg: GenerateClientMessageArg): ClientMessage;
}

const generateMessage = (payload: MessageMaterial) => {
  if (Array.isArray(payload)) {
    return payload.map((v) => generateSingleMessage(v));
  } else {
    return [generateSingleMessage(payload)];
  }
};

const generateSystemMessage: GenerateClientMessageFn = ({
  payload,
  ...config
}) => {
  return {
    id: uuid(),
    from: MessageFrom.SYSTEM,
    time: moment().valueOf(),
    messages: generateMessage(payload).map((v: any) => ({
      ...v,
      type: MessageType.system_info_msg,
    })),
    ...(config || {}),
  };
};

const generateOtherMessage: GenerateClientMessageFn = ({
  payload,
  ...config
}) => {
  return {
    id: uuid(),
    from: MessageFrom.OTHERS,
    time: moment().valueOf(),
    messages: generateMessage(payload),
    ...(config || {}),
  };
};

const generateBotMessage: GenerateClientMessageFn = ({
  payload,
  ...config
}) => {
  return {
    id: uuid(),
    from: MessageFrom.BOT,
    time: moment().valueOf(),
    messages: generateMessage(payload),
    ...(config || {}),
  };
};

const generateSelfMessage: GenerateClientMessageFn = ({
  payload,
  ...config
}) => {
  let messages = [];
  if (Array.isArray(payload)) {
    messages = payload.map((v) => ({
      ...generateSingleMessage(v),
      type: get(v, "type", MessageType.client_msg),
    }));
  } else {
    messages = [
      {
        type: get(payload, "type", MessageType.client_msg),
        ...generateSingleMessage(payload),
      },
    ];
  }

  return {
    id: uuid(),
    from: MessageFrom.SELF,
    time: moment().valueOf(),
    messages,
    ...config,
  };
};

export const generateBotLoadingMessage = () => {
  return {
    from: MessageFrom.BOT,
    time: moment().valueOf(),
    isBotLoadingMessage: true,
    messages: [
      {
        type: MessageType.client_receive_loading,
        data: {},
        clientTimeStamp: moment().valueOf(),
      },
    ],
  };
};

export const pushSystemMessage = createAsyncThunk(
  "chat/pushSystemMessage",
  (arg: GenerateClientMessageArg, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    const msg = generateSystemMessage(arg);
    dispatch(pushMessage(msg));
  }
);

export const pushOtherMessage = createAsyncThunk(
  "chat/pushOtherMessage",
  (arg: GenerateClientMessageArg, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    const msg = generateOtherMessage(arg);
    dispatch(pushMessage(msg));
  }
);

export const pushBotMessage = createAsyncThunk(
  "chat/pushBotMessage",
  (arg: GenerateClientMessageArg, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    const msg = generateBotMessage(arg);
    dispatch(pushMessage(msg));
  }
);

export const pushSelfMessage = createAsyncThunk(
  "chat/pushSelfMessage",
  (arg: GenerateClientMessageArg, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    const msg = generateSelfMessage(arg);
    dispatch(pushMessage(msg));
  }
);

function generateTimeMessage(time = moment().valueOf()) {
  let timestamp = moment(time);
  if (!timestamp.isValid()) {
    timestamp = moment();
  }
  let today = moment();
  let yesterday = moment().add(-1, "days");
  let timeStr = "";
  const area = timestamp.get("hour") > 12 ? "下午 " : "上午 ";
  if (timestamp.isSame(today, "day")) {
    timeStr = `${area}${timestamp.format("HH:mm")}`;
  }
  if (timestamp.isSame(yesterday, "day")) {
    timeStr = `昨天 ${area}${timestamp.format("HH:mm")}`;
  }
  if (timestamp.isBefore(yesterday, "day")) {
    timeStr = `${timestamp.format("YYYY-MM-DD")} ${area}${timestamp.format(
      "HH:mm"
    )}`;
  }

  return {
    id: uuid(),
    from: MessageFrom.SYSTEM,
    time: moment().valueOf(),
    messages: [
      {
        type: MessageType.client_timestamp,
        clientTimeStamp: timestamp.valueOf(),
        data: {
          content: timeStr,
        },
      },
    ],
  };
}

const timeCheck = function (last: Messages, val: ClientMessage) {
  if (last.length < 1) return false;
  const _prev = last[last.length - 1];
  const prev = compose(moment)(get(_prev, "time"));
  const curr = compose(moment)(get(val, "time"));
  const duration = moment.duration(curr.diff(prev)).asSeconds();
  if (duration > 120) {
    const timeMsg = generateTimeMessage(curr.valueOf());
    return timeMsg;
  }
};

export const sendMessage = createAsyncThunk(
  "chat/sendMessage",
  async (
    {
      message,
      sendToService = true,
    }: { message: string; sendToService?: boolean },
    thunkAPI
  ) => {
    const dispatch = thunkAPI.dispatch;
    try {
      const state = thunkAPI.getState() as RootState;
      const sending = mapSending(state);
      if (sending) return;
      dispatch(setSending(true));
      dispatch(setQuestions([]));
      if (sendToService) {
        dispatch(pushSelfMessage({ payload: message }));
        dispatch(setInputValue(""));
        dispatch(showBotLoadingMessage({}));
        const res = await chatService.sendMessage(message);
        dispatch(hideBotLoadingMessage({}));
        const success = get(res, "code") === StatusCode.success;
        const resMessage = get(res, "message", "发送失败");
        if (success) {
          const result = get(res, "result");
          dispatch(flatMessages({ result }));
        } else {
          dispatch(pushBotMessage({ payload: resMessage }));
        }
      } else {
        await dispatch(pushSelfMessage({ payload: message }));
      }
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(setSending(false));
    }
  }
);

export const sendMessageLLM = createAsyncThunk(
  'chat/sendMessage',
  async (
    { query, session_id, sendToService = true }: { query: string; session_id: string, sendToService?: boolean },
    thunkAPI
  ) => {
    if (!query) return;
    const dispatch = thunkAPI.dispatch;
    try {
      const state = thunkAPI.getState() as RootState;
      const sending = mapSending(state);
      if (sending) return;
      dispatch(setSending(true));
      dispatch(setQuestions([]));
      if (sendToService) {
        dispatch(pushSelfMessage({ payload: query }));
        dispatch(setInputValue(''));
        dispatch(showBotLoadingMessage({}));
        const params = { query, session_id } as any;
        dispatch(setStreamFinish(0));
        chatService.sendMessageLLM(params, (res: any) => {
          dispatch(hideBotLoadingMessage({}));
          const success = get(res, 'code') == StatusCode.success;
          const resMessage =
            get(res, 'reply') || get(res, 'ui_response', '发送失败');
          const uiResponse = get(res, 'ui_response');
          const message_id = get(res, 'message_id');
          const dialog_id = get(res, 'dialog_id');
          const doc_list = get(res, 'doc_list');
          const url_list = get(res, 'url_list') || [];
          const streamFinish = get(res, 'stream_finish');
          dispatch(setStreamFinish(streamFinish));
          if (success) {
            if (uiResponse) {
              dispatch(setResponseType(0))
              dispatch(flatMessages({ result: uiResponse.result }));
              return;
            }
            dispatch(setResponseType(1))
            const result: any = {
              section_list: [
                {
                  card_list: [
                    {
                      data: {
                        content: res.reply || '?'
                      },
                      type: 1,
                      message_id: message_id
                    },
                    ...url_list
                  ]
                }
              ]
            };

            if (doc_list?.length) {
              result.section_list[0].card_list.push({
                data: {
                  file_list: doc_list,
                  title: '相关资料'
                },
                type: 300
              });
            }

            if (dialog_id) {
              result.section_list[0].card_list.push({
                data: {
                  like_button_list: [
                    {
                      action: 20,
                      callback: {
                        dialog_id: dialog_id
                      },
                      icon: '1.svg'
                    },
                    {
                      action: 21,
                      callback: {
                        dialog_id: dialog_id
                      },
                      icon: '2.svg'
                    }
                  ]
                },
                type: 201
              });
            }

            const messages = store.getState().chat.messages;
            const lastMessage = messages[messages?.length - 1];
            // @ts-ignore
            if (lastMessage?.messages?.[0]?.message_id === message_id) {
              dispatch(
                setLastOneMessage({
                  result,
                  index: result?.section_list?.length
                })
              );
            } else {
              dispatch(flatMessages({ result }));
            }
          } else {
            dispatch(pushBotMessage({ payload: resMessage }));
          }
        });
      } else {
        await dispatch(pushSelfMessage({ payload: query }));
      }
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(setSending(false));
    }
  }
);

// 设置 messages 最后一条数据
export const setLastBotMessage = createAsyncThunk(
  'chat/setLastBotMessage',
  (arg: any, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    const msg = generateBotMessage(arg);
    dispatch(setLastMessage(msg));
  }
);


export const makeAction = createAsyncThunk(
  "chat/makeAction",
  async (
    { id, data, message = "" }: { id: number; data: any; message?: string },
    thunkAPI
  ) => {
    const dispatch = thunkAPI.dispatch;
    const state = thunkAPI.getState() as RootState;
    const streamFinish = store.getState().chat.streamFinish;

    /** 流式输出时不执行 */
    if(streamFinish === 0) {
      return
    }
    
    if (isIMMode() && get(mapConversation(state), "finish")) return;

    isBotMode() && message && dispatch(pushSelfMessage({ payload: message }));

    dispatch(showBotLoadingMessage({}));
    const res = await chatService.makeAction(id, data);
    dispatch(hideBotLoadingMessage({}));
    const success = get(res, "code") === StatusCode.success;
    const resMessage = get(res, "message", `${message}发送失败`);
    if (success && !isLoginMode()) {
      const result = get(res, "result");
      const from = isIMMode() ? MessageFrom.OTHERS : MessageFrom.BOT;
      const config = isIMMode()
        ? compose(
            (data) => ({
              avatar: data.to_user_avatar,
              name: data.to_user_name,
            }),
            mapConversation
          )(state)
        : {};
      dispatch(
        flatMessages({
          result,
          from,
          config,
        })
      );
    } else if(!isLoginMode()) {
      // dispatch(pushBotMessage({ payload: resMessage }));
      antdMessage.error(resMessage);
      throw Error(resMessage);
    }
    return get(res, "result");
  }
);

const mapPageAction = createAsyncThunk(
  "chat/mapPageAction",
  (page: any, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    const { type } = page;
    const fn = mapPageTypeHandler.get(type);
    if (typeof fn === "function") {
      fn({ page, dispatch, history } as any);
    }
  }
);

function withTimestamp(msgs: any[]) {
  return msgs.map((v: any) => ({
    ...v,
    clientTimeStamp: moment().valueOf(),
  }));
}

const flatMessages = createAsyncThunk(
  "chat/flatMessages",
  (
    {
      result,
      from = MessageFrom.BOT,
      config,
    }: { result: any; from?: MessageFrom; config?: Partial<ClientMessage> },
    thunkAPI
  ) => {
    const dispatch = thunkAPI.dispatch;
    const isObject =
      Object.prototype.toString
        .call(result)
        .match(/\s(\w*)]$/)?.[1]
        ?.toLowerCase() === "object";

    if (isObject) {
      for (let k of Object.keys(result)) {
        const list = get(result, `[${k}]`);

        if (k === im_button_list_key) {
          dispatch(setConversation({ buttons: list }));
        } else if (k === section_list_key) {
          for (let n of list) {
            const page = get(n, "page");
            page && dispatch(mapPageAction(page));

            const messages = get(n, "card_list") as ServerMessage;
            if (Array.isArray(messages) && messages.length > 0) {
              const fromHistory = get(config, "fromHistory");
              const withTimeMessages = withTimestamp(messages);
              const rawMessages = (
                fromHistory ? messages : withTimeMessages
              ) as any;
              if (from === MessageFrom.SELF) {
                dispatch(pushSelfMessage({ payload: rawMessages, ...config }));
              } else if (from === MessageFrom.BOT) {
                dispatch(pushBotMessage({ payload: rawMessages, ...config }));
              } else if (from === MessageFrom.OTHERS) {
                dispatch(pushOtherMessage({ payload: rawMessages, ...config }));
              } else {
                dispatch(pushOtherMessage({ payload: rawMessages, ...config }));
              }
            }
          }
        } else if (k === im_notice_list_key) {
          dispatch(pushSystemMessage({ payload: list }));
        } else if (k === im_event_list_key) {
          dispatch(IMEventHandler({ events: list }));
        }
      }
    }
  }
);

export const flatHistoryeMessages = createAsyncThunk(
  'chat/flatHistoryeMessages',
  (
    {
      result,
      from = MessageFrom.BOT,
      config
    }: { result: any; from?: MessageFrom; config?: Partial<ClientMessage> },
    thunkAPI
  ) => {
    const dispatch = thunkAPI.dispatch;
    const isObject =
      Object.prototype.toString
        .call(result)
        .match(/\s(\w*)]$/)?.[1]
        ?.toLowerCase() === 'object';

    if (isObject) {
      for (let k of Object.keys(result)) {
        const list = get(result, `[${k}]`);
        if (k === im_history_list_key) {
          dispatch(setHistoryMessages(list));
        }
      }
    }
  }
);

const IMEventHandler = createAsyncThunk(
  "chat/IMEventHandler",
  ({ events }: { events: any[] }, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    events.forEach((event) => {
      const eventType = get(event, "type");
      const eventMessage = get(event, "message");
      const action = get(event, "action");
      const callback = get(event, "callback");
      if (eventType === IMEventTye.conversation_ended) {
        dispatch(
          countdownForRefresh({
            title: eventMessage,
            cb: () => {
              history.replace("/chat");
              if (action && callback) {
                dispatch(makeAction({ id: action, data: callback }));
              }
            },
          })
        );
      } else if (eventType === IMEventTye.conversation_transferred) {
        dispatch(
          countdownForRefresh({
            title: eventMessage,
            cb: () => {
              window.location.reload();
              // history.replace("/chat");
              // if (action && callback) {
              //   dispatch(makeAction({ id: action, data: callback }));
              // }
            },
          })
        );
      }
    });
  }
);

const getQuestions = async (val: string) => {
  const res = await chatService.questionAutoMatch(val);
  return get(res, "result.question_list", []);
};

let getQuestionsTimer: any = null;

export const autoComplete = createAsyncThunk(
  "chat/autoComplete",
  async (val: string, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    if (getQuestionsTimer) {
      clearTimeout(getQuestionsTimer);
    }
    getQuestionsTimer = setTimeout(async () => {
      const currentVal = mapInputValue(thunkAPI.getState() as RootState);
      if (!currentVal) {
        dispatch(setQuestions([]));
        clearTimeout(getQuestionsTimer);
        getQuestionsTimer = null;
        return;
      }
      const res = await getQuestions(val);
      const currentValAfter = mapInputValue(thunkAPI.getState() as RootState);
      if (Array.isArray(res) && res.length > 0 && currentValAfter) {
        dispatch(setQuestions(res));
      } else {
        dispatch(setQuestions([]));
      }
      clearTimeout(getQuestionsTimer);
      getQuestionsTimer = null;
    }, 500);
  }
);

export const handleLoginInputChange = createAsyncThunk(
  "chat/handleLoginInputChange",
  async (value: string, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    const state = thunkAPI.getState() as RootState;
    const flow = compose(getLoginFlow, mapLoginInfo)(state);
    let next = (value.match(/\d+/g)?.join("") || "").substr(0, 20);
    const len =
      LoginFlow.inputPhoneNumber === flow || LoginFlow.signAgreement === flow
        ? 20
        : 6;
    next = next.substr(0, len);
    next = trim(next);
    dispatch(setInputValue(next));
  }
);

export const handleInputChange = createAsyncThunk(
  "chat/handleInputChange",
  async (value: string, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    const state = thunkAPI.getState() as RootState;
    const mode = mapChatMode(state);
    let next =
      typeof value === "string" || typeof value === "number" ? value : "";
    dispatch(setInputValue(next));
    mode === ChatMode.BOT && dispatch(autoComplete(next));
  }
);

export const handleSendMessage = createAsyncThunk(
  "chat/handleSendMessage",
  (arg: any, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const dispatch = thunkAPI.dispatch;
    const inputValue = mapInputValue(state);
    if (inputValue) {
      // dispatch(sendMessage({ message: inputValue }));
      dispatch(sendMessageLLM({ query: inputValue, ...arg }));
    }
    // else {
    //   confirm({
    //     title: "不能发送空消息",
    //     okText: "确定",
    //     cancelButtonProps: { style: { display: "none" } },
    //   });
    // }
  }
);

export const toReadConversation = createAsyncThunk(
  "chat/toReadConversation",
  async (arg: any, thunkAPI) => {
    if (!im) return;
    const state = thunkAPI.getState() as RootState;
    const conversation = mapConversation(state);
    const from_user_id = get(conversation, "from_user_id");
    const to_user_id = get(conversation, "to_user_id");
    const task_id = get(conversation, "task_id");
    try {
      const res = await IMService.readConversation({
        task_id,
        from_account: from_user_id,
        to_account: to_user_id,
      });
      console.log(`上报已读事件: 对方user_id [${to_user_id}]`, res);
    } catch (e) {
      console.warn("setMessageRead error:", e);
    }
  }
);

export const receiveConversationRead = createAsyncThunk(
  "chat/receiveConversationRead",
  async (arg: any, thunkAPI) => {}
);

export const chatSlice = createSlice({
  name: "chat",
  initialState: initialState,
  reducers: {
    setMenu: (state, action: PayloadAction<IMenu>) => {
      state.menu = action.payload;
    },
    setMessages: (state, action: PayloadAction<Messages>) => {
      if (state.mode === ChatMode.IM) {
        state.IMMessages = action.payload;
      } else {
        state.messages = action.payload;
      }
    },
    resetHistoryMessages: (state, action: PayloadAction<Messages>) => {
      state.historyMessages = [];
    },
    setHistoryMessages: (state, action: PayloadAction<Messages>) => {
      state.historyMessages = action.payload;
    },
    pushMessage: (state, action: PayloadAction<ClientMessage>) => {
      const msg = action.payload;
      const fromHistory = get(msg, "fromHistory");
      const time = get(msg, "time");
      if (state.mode === ChatMode.IM) {
        if (fromHistory) {
          const timeMsg = generateTimeMessage(time);
          timeMsg && state.IMMessages.push(timeMsg);
        } else {
          const timeMsg = timeCheck(state.IMMessages, msg);
          timeMsg && state.IMMessages.push(timeMsg);
        }
        state.IMMessages.push(msg);
      } else {
        const timeMsg = timeCheck(state.messages, msg);
        timeMsg && state.messages.push(timeMsg);
        state.messages.push(msg);
      }

      state.scrollToBottomTrigger += 1;
      state.inputFocusTrigger += 1;
    },
    setInputValue: (state, action: PayloadAction<string>) => {
      state.inputValue = action.payload;
    },
    setQuestions: (state, action: PayloadAction<Questions>) => {
      state.questions = action.payload;
    },
    scrollToBottom: (state) => {
      state.scrollToBottomTrigger += 1;
    },
    inputFocus: (state) => {
      state.inputFocusTrigger += 1;
    },
    toggleMenuShow: (state, action: PayloadAction<boolean | undefined>) => {
      state.menu.show =
        typeof action.payload === "boolean" ? action.payload : !state.menu.show;
    },
    setIMLoading: (state, action: PayloadAction<boolean>) => {
      state.IMLoading = action.payload;
    },
    setIMReady: (state, action: PayloadAction<boolean>) => {
      state.IMReady = action.payload;
    },
    setChatMode: (state, action: PayloadAction<ChatMode>) => {
      state.mode = action.payload;
    },
    setConversation: (state, action: PayloadAction<Partial<Conversation>>) => {
      state.conversation = { ...state.conversation, ...action.payload };
    },
    resetChatSlice: (state) => {
      Object.assign(state, initialState);
    },
    showBotLoadingMessage: (state, action: PayloadAction<any>) => {
      if (state.hasBotLoadingMessage) return;
      state.hasBotLoadingMessage = true;
      const loadingMessage = generateBotLoadingMessage() as any;
      state.messages.push(loadingMessage);
    },
    hideBotLoadingMessage: (state, action: PayloadAction<any>) => {
      state.messages = state.messages.filter((v) => {
        if (get(v, "isBotLoadingMessage")) {
          return false;
        }
        return true;
      });
      state.hasBotLoadingMessage = false;
    },
    setSending: (state, action: PayloadAction<boolean>) => {
      state.sending = action.payload;
    },
    setIMSending: (state, action: PayloadAction<boolean>) => {
      state.IMSending = action.payload;
    },
    setIMMessagesRead: (state) => {
      state.IMMessages = state.IMMessages.map((v) =>
        v.from === MessageFrom.SELF ? { ...v, read: true } : v
      );
    },
    filtedCompanySelector(state) {
      state.messages = state.messages.filter(v => {
        return !(get(v, 'from') === MessageFrom.BOT && get(v, 'messages', []).find(vv => get(vv, 'type') === MessageType.client_chose_companies))
      })
    },
    setLastMessage: (state, action: PayloadAction<ClientMessage>) => {
      if (state.mode === ChatMode.IM) {
        state.IMMessages[state.IMMessages.length - 1] = action.payload;
      } else {
        state.messages[state.messages.length - 1] = action.payload;
      }
    },
    setStreamFinish: (state, action: PayloadAction<0 | 1>) => {
      state.streamFinish = action.payload;
    },
    setResponseType: (state, action: PayloadAction<0 | 1>) => {
      state.responseType = action.payload;
    }
  },
  extraReducers: {
    [getMenuList.fulfilled.toString()]: (state, action) => {
      if (action.payload) {
        state.menu = { ...action.payload, show: state.menu.show };
      }
    },
    [receiveConversationRead.fulfilled.toString()]: (state, action) => {
      const msgs = state.IMMessages;
      for (let i = msgs.length - 1; i >= 0; i--) {
        if (msgs[i].from === MessageFrom.SELF) {
          msgs[i].read = true;
        }
      }
    },
  },
});

export const mapQuestions = (state: RootState) => state.chat.questions;
export const mapMenu = (state: RootState) => state.chat.menu;
export const mapMenuShow = (state: RootState) => state.chat.menu.show;
export const mapChat = (state: RootState) => state.chat;
export const mapChatMode = (state: RootState) => state.chat.mode;
export const detectIsIMMode = (state: RootState) =>
  state.chat.mode === ChatMode.IM;
export const mapMessages = createDraftSafeSelector(
  mapChat,
  mapChatMode,
  (chat, mode) => (mode === ChatMode.IM ? chat.IMMessages : chat.messages)
);
export const mapHistoryMessages = createDraftSafeSelector(mapChat, chat => {
  return chat.historyMessages;
});
export const mapInputValue = (state: RootState) => state.chat.inputValue;
export const mapScrollToBottomTrigger = (state: RootState) =>
  state.chat.scrollToBottomTrigger;
export const mapInputFocusTrigger = (state: RootState) =>
  state.chat.inputFocusTrigger;
export const mapConversation = (state: RootState) => state.chat.conversation;
export const mapIMReady = (state: RootState) => state.chat.IMReady;
export const mapIMLoading = (state: RootState) => state.chat.IMReady;
export const mapStreamFinish = (state: RootState) => state.chat.streamFinish;
export const mapResponseType = (state: RootState) => state.chat.responseType;
export const mapIMConversationFinish = createSelector(
  mapConversation,
  (conversation) => get(conversation, "finish")
);
export const mapIMPageReady = createSelector(
  mapConversation,
  mapIMReady,
  (conversation, ready) => get(conversation, "task_id") && ready
);
export const mapIMButtons = createSelector(mapConversation, (conversation) =>
  get(conversation, "buttons", [])
);
export const mapSending = createSelector(mapChat, (chat) => chat.sending);
export const mapIMSending = createSelector(mapChat, (chat) => chat.IMSending);
export const mapIMConversationID = createSelector(
  mapChat,
  (chat) => `C2C${chat.conversation.to_user_id}`
);
export const mapIMReadStatusVisiable = (state: RootState) =>
  state.chat.conversation.read_status_visible;

export const {
  setQuestions,
  setMenu,
  setMessages,
  resetHistoryMessages,
  setHistoryMessages,
  pushMessage,
  setInputValue,
  scrollToBottom,
  inputFocus,
  toggleMenuShow,
  setIMLoading,
  setIMReady,
  setChatMode,
  setConversation,
  resetChatSlice,
  showBotLoadingMessage,
  hideBotLoadingMessage,
  setSending,
  setIMSending,
  setIMMessagesRead,
  filtedCompanySelector,
  setLastMessage,
  setStreamFinish,
  setResponseType
} = chatSlice.actions;

export default chatSlice.reducer;

export const mapPageTypeToPath = new Map([
  [1, "/mentor-assignment"], // 导师分配
  [5, "/addressBook"], // 通讯录 (无任务)
  [7, "/form"], // 表单
  [8, "/form"], // 表单审核
  [9, "/profile"], // 个人资料
]);

const formPageHandler = ({ page, dispatch, history }: any) => {
  setFormModalData({ ...page });
  setFormModalVisible(true);
};

export enum PageType {
  mentor_assignment = 1,
  address_book = 5,
  jump_page = 6,
  form = 7,
  form_check = 8,
  profile = 9,
  notice = 11,
  im = 12,
  chatbot = 2,
  quote = 13,
  im_popup_evaluation = 14,
  form_edit_current = 15,
  tasklist = 16,
}

export const mapPageTypeHandler = new Map([
  [
    PageType.mentor_assignment,
    ({ page, dispatch, history }: any) => {
      const data = get(page, "data");
      const action = get(page, "action");
      const callback = get(page, "callback");
      const department_id = get(data, "department_id", "");
      const keyword = get(data, "keyword", "");
      dispatch(setAssignTutorItem({ data, action, callback }));
      dispatch(
        setAddressBook({
          visible: true,
          department_id,
          keyword,
          type: ADDRESSBOOKTYPE.ASSIGNTUTOR,
        })
      );
    },
  ],
  [
    PageType.address_book,
    ({ page, dispatch, history }: any) => {
      const data = get(page, "data");
      const department_id = get(data, "department_id", "");
      const keyword = get(data, "keyword", "");
      dispatch(
        setAddressBook({
          visible: true,
          department_id,
          keyword,
          type: ADDRESSBOOKTYPE.ADDRESSBOOK,
        })
      );
    },
  ],
  [
    PageType.jump_page,
    ({ page, dispatch, history }: any) => {
      setFormModalData({ ...page });
      const url = get(page, "data.url");
      if (url) {
        window.location.href = !url.startsWith("http")
          ? window.location.origin + "/chatbot-pc/#/" + url
          : url;
      }
    },
  ],
  [PageType.form, formPageHandler],
  [PageType.form_check, formPageHandler],
  [
    PageType.profile,
    ({ page, dispatch, history }: any) => {
      setProfileVisible(true, page);
      // history.push("/profile");
    },
  ],
  [
    PageType.notice,
    ({ page, dispatch, history }: any) => {
      const id = get(page, "data.id");
      dispatch(
        setNoticeDetail({
          notice_id: id,
          visible: true,
        })
      );
      // history.push(`/notice/${id}`);
    },
  ],
  [
    PageType.im,
    ({ page, dispatch, history }: any) => {
      const task_id = get(page, "task_id");
      if (task_id) {
        history.push(`/im?task_id=${task_id}`);
      }
    },
  ],
  [
    PageType.chatbot,
    ({ page, dispatch, history }: any) => {
      history.replace(`/chat`);
      const remind = get(page, "remind");
      remind &&
        chatPageFinishedCallbacks.push(() => {
          dispatch(pushBotMessage({ payload: remind }));
        });
    },
  ],
  [
    PageType.quote,
    ({ page, dispatch, history }: any) => {
      setKnowledgeQuery(get(page, "data", {}));
      setKnowledgeVisible(true);
      // 知识引用弹窗
    },
  ],
  [
    PageType.im_popup_evaluation,
    ({ page, dispatch, history }: any) => {
      closeAllModal();
      setScoreData(get(page, "data"));
      setScoreVisible(true);
    },
  ],
  // 跳转到当前编辑的表单页
  [
    PageType.form_edit_current,
    ({ page, dispatch, history }: any) => {
      setFormModalData({ ...page });
      setFormModalVisible(true);
    },
  ],
  [
    PageType.tasklist,
    ({ page, dispatch, history }: any) => {
      // const status = page?.data?.type || 1;
      // window.localStorage.setItem("tasktab", `${status - 1}`);
      const status = `${get(page, "data.type", 1) - 1}`;
      window.localStorage.setItem("taskTab", status);
      setTaskModalVisible(true);
    },
  ],
]);

export const createIMMessage = ({
  to,
  data,
  task_id,
  conversation_id,
}: {
  to: string;
  data: any;
  task_id: string;
  conversation_id: string;
}) => {
  if (im) {
    return im.createCustomMessage({
      to,
      conversationType: TIM.TYPES.CONV_C2C,
      payload: {
        data: JSON.stringify(data),
        extension: `${task_id}`,
        description: `${conversation_id}`,
      },
    });
  }
};

export const sendIMMessage = createAsyncThunk(
  "chat/sendIMMessage",
  async ({ message }: any, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const dispatch = thunkAPI.dispatch;
    const IMReady = mapIMReady(state);
    if (im && IMReady) {
      console.log("IM发消息: ", message);
      await im.sendMessage(message);
      dispatch(nonOperationCountdown({}));
    }
  }
);

export const handleSendIMMessage = createAsyncThunk(
  "chat/handleSendIMMessage",
  async (
    {
      payload,
      cleanInput = true,
      formatToCard = true,
    }: { payload?: any; cleanInput?: boolean; formatToCard?: boolean },
    thunkAPI
  ) => {
    const state = thunkAPI.getState() as RootState;
    const dispatch = thunkAPI.dispatch;

    const inputValue = payload || mapInputValue(state);
    if (!inputValue) return;

    const IMSending = mapIMSending(state);
    console.log("IMSending: ", IMSending);
    if (IMSending || !isIMMode()) return;

    try {
      dispatch(setIMSending(true));
      const conversation = mapConversation(state);
      const conversation_id = get(conversation, "conversation_id");
      const task_id = get(conversation, "task_id");
      const to_user_id = get(conversation, "to_user_id");

      const message = createIMMessage({
        conversation_id,
        task_id,
        to: to_user_id,
        data: formatToCard ? generateSingleMessageCard(inputValue) : payload,
      });
      const res = await dispatch(sendIMMessage({ message }));
      if (!isIMMode()) {
        dispatch(setIMSending(false));
        return;
      }
      const error = get(res, "error");
      if (error) {
        dispatch(setIMSending(false));
        message.error("消息发送失败，请重试。");
        return;
      }
      cleanInput && dispatch(setInputValue(""));
      formatToCard && dispatch(pushSelfMessage({ payload: inputValue }));
      dispatch(setIMSending(false));
    } catch (e) {
      dispatch(setIMSending(false));
    }
  }
);

export const generateSingleMessageCard = (payload: any) => {
  return {
    section_list: [
      {
        card_list: [
          payload && payload.constructor === Object
            ? {
                type: MessageType.text,
                data: {},
                ...payload,
              }
            : {
                type: MessageType.text,
                data: { content: payload },
              },
        ],
      },
    ],
  };
};

export const handleSendIMImageMessage = createAsyncThunk(
  "chat/handleSendIMImageMessage",
  (arg: any, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    const state = thunkAPI.getState() as RootState;
    const IMSending = mapIMSending(state);
    if (IMSending) return;

    const uploadImageKey = "uploadImageKey";
    const onUpload = async (e: any) => {
      try {
        const file = get(e, "target.files[0]");
        if (!file) return;
        const size = get(file, "size");
        const isLt2M = size / 1024 / 1024 < 2;
        if (!isLt2M) {
          Modal.warning({
            title: "图片体积必须小于2M",
            onOk() {},
            centered: true,
          });
          return;
        }
        message.loading({
          content: "图片消息发送中",
          duration: 0,
          key: uploadImageKey,
        });
        let fd = new FormData();
        fd.append("file", file);
        const res = await AuthService.uploadFile(fd);
        const code = get(res, "code");
        const uuid = get(res, "result.uuid");
        if (code === StatusCode.success && uuid) {
          dispatch(
            handleSendIMMessage({
              payload: {
                data: { uuid },
                type: MessageType.img,
              },
              cleanInput: false,
            })
          );

          // const message = createIMMessage({
          //   conversation_id: conversation.conversation_id,
          //   task_id: conversation.task_id,
          //   to: conversation.to_user_id,
          //   data: generateSingleMessageCard({
          //     data: { uuid },
          //     type: MessageType.img,
          //   }),
          // });

          // dispatch(sendIMMessage({ message }));
          // dispatch(
          //   pushSelfMessage({
          //     payload: {
          //       type: MessageType.img,
          //       data: { uuid },
          //     },
          //   })
          // );
        }

        message.success({ content: "图片消息发送成功", key: uploadImageKey });
      } catch (e) {
        console.log(e);
        message.error({
          content: "图片消息发送失败，请重试",
          key: uploadImageKey,
        });
      }
    };

    const uploadImage = () => {
      try {
        let el = document.createElement("input");
        el.setAttribute("type", "file");
        el.setAttribute("accept", "image/jpg, image/png");
        el.setAttribute("hidden", "true");
        el.addEventListener("change", onUpload);
        document.body.appendChild(el);
        el.click();
      } catch (e) {
        console.log(e);
      }
    };

    uploadImage();
  }
);

export const handleIMMessageReceived = createAsyncThunk(
  "chat/handleIMMessageReceived",
  (messages: any, thunkAPI) => {
    if (!isIMMode()) return;
    const dispatch = thunkAPI.dispatch;
    const state = thunkAPI.getState() as RootState;
    const conversation = mapConversation(state);
    const cur_conversation_id = conversation.conversation_id;
    const from_user_id = get(conversation, "from_user_id");
    const msgs = get(messages, "data");

    for (const msg of msgs) {
      const conversation_id = get(msg, "payload.description");
      if (conversation_id !== cur_conversation_id) {
        continue;
      }

      const jsonStr = get(msg, "payload.data");
      const msgFrom = get(msg, "from");
      const isFromSelf = msgFrom === from_user_id;
      const avatar = get(msg, "avatar");
      const name = get(msg, "nick");

      try {
        const data = JSON.parse(jsonStr);

        for (const k of Object.keys(data)) {
          if (k === section_list_key) {
            if (isFromSelf) {
              dispatch(flatMessages({ result: data, from: MessageFrom.SELF }));
            } else {
              dispatch(
                flatMessages({
                  result: data,
                  from: MessageFrom.OTHERS,
                  config: {
                    avatar: getFilePrefix(avatar),
                    name: name,
                  },
                })
              );
            }
          } else if (k === im_event_list_key) {
            dispatch(flatMessages({ result: data }));
          } else if (k === im_notice_list_key) {
            dispatch(flatMessages({ result: data }));
          } else if (k === im_button_list_key) {
            dispatch(flatMessages({ result: data }));
          }
        }
      } catch (e) {
        console.log(e);
      }
    }

    store.dispatch(toReadConversation({}));
    const customIMReadyMessage = get(messages, "data", []).some(
      (v: any) =>
        get(v, "from") !== from_user_id &&
        get(v, "payload.data").indexOf("card_list") > -1
    );
    customIMReadyMessage && store.dispatch(receiveConversationRead({}));
  }
);

export const cleanIM = createAsyncThunk(
  "chat/cleanIM",
  (arg: any, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    dispatch(setIMLoading(false));
    dispatch(setIMReady(false));
    dispatch(setIMSending(false));
    // dispatch(setChatMode(ChatMode.BOT));
    if (im) {
      im.logout();
      im.off(TIM.EVENT.SDK_READY, IMReadyHandler);
      im.off(TIM.EVENT.SDK_NOT_READY, IMNotReadyHandler);
      im.off(TIM.EVENT.MESSAGE_RECEIVED, IMMessageReceivedHandler);
      im.off(TIM.EVENT.MESSAGE_READ_BY_PEER, IMMessageReadHandler);
      im.off(TIM.EVENT.KICKED_OUT, IMKickedOutHandler);
      im.off(TIM.EVENT.ERROR, IMErrorHandler);
      im = null;
    }
    clearTimeout(IMNonOperationTimer);
    // console.log("清理计时");
  }
);

export const setMessageRead = createAsyncThunk(
  "chat/setMessageRead",
  (arg: any, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const im_conversation_id = mapIMConversationID(state);
    if (im && im_conversation_id) {
      im.setMessageRead({ conversationID: im_conversation_id });
    }
  }
);

export const countdownForRefresh = createAsyncThunk(
  "chat/countdownForRefresh",
  (
    { title, cb, time = 10 }: { title: string; cb?: () => void; time?: number },
    thunkAPI
  ) => {
    const dispatch = thunkAPI.dispatch;
    dispatch(cleanIM({}));

    function urlCheck() {
      const url = window.location.hash;
      return url.indexOf("/im?task_id=") > -1;
    }
    if (!urlCheck()) return;

    const finishedCB = () => {
      if (!urlCheck()) return;
      typeof cb === "function" ? cb() : window.location.reload();
      modal.destroy();
    };

    let countdown = time;

    const modal = Modal.warning({
      title: title,
      icon: null,
      okText: `确定（${countdown}）`,
      onOk: finishedCB,
      centered: true,
    });

    function countdownFn(timer: any) {
      timer = setTimeout(() => {
        if (!urlCheck()) {
          modal.destroy();
          return;
        }
        if (countdown - 1 >= 0) {
          countdown -= 1;
          modal.update((prevConfig) => ({
            ...prevConfig,
            okText: `确定（${countdown}）`,
          }));
          countdownFn(timer);
        } else {
          finishedCB();
        }
      }, 1000);
    }

    let timer;
    countdownFn(timer);
  }
);

function IMReadyHandler(event: any) {
  console.log("IM初始化成功");
  store.dispatch(setIMLoading(false));
  store.dispatch(setIMReady(true));

  const state = store.getState() as RootState;
  const conversation = mapConversation(state);
  const prologues = get(conversation, "prologues", []);
  const task_id = get(conversation, "task_id");

  IMService.noticeServerIMLogined(task_id);

  store.dispatch(toReadConversation({}));

  prologues.forEach(async (str: string) => {
    store.dispatch(handleSendIMMessage({ payload: str, cleanInput: false }));
    // const data = generateSingleMessageCard(str);
    // const message = createIMMessage({
    //   to: to_user_id,
    //   task_id,
    //   conversation_id,
    //   data,
    // });
    // await store.dispatch(sendIMMessage({ message }));
    // store.dispatch(pushSelfMessage({ payload: str }));
  });
  store.dispatch(scrollToBottom());
}

function IMNotReadyHandler(event: any) {
  console.log("IM离线");
  store.dispatch(setIMLoading(false));
  store.dispatch(setIMReady(false));
}

function IMMessageReceivedHandler(event: any) {
  console.log("IM收到消息: ", event);
  store.dispatch(handleIMMessageReceived(event));
}

function IMMessageReadHandler(event: any) {
  // SDK 收到对端已读消息的通知，即已读回执。使用前需要将 SDK 版本升级至 v2.7.0 或以上。仅支持单聊会话。
  console.log("腾讯IM已读事件：", event);
  // store.dispatch(setIMMessagesRead());
  store.dispatch(receiveConversationRead({}));
  // event: any.name - TIM.EVENT.MESSAGE_READ_BY_PEER
  // event: any.data - event: any.data - 存储 Message 对象的数组 - [Message] - 每个 Message 对象的 isPeerRead 属性值为 true
}

function IMKickedOutHandler(event: any) {
  const type = get(event, "data.type");
  if (
    [
      TIM.TYPES.KICKED_OUT_MULT_ACCOUNT,
      TIM.TYPES.KICKED_OUT_MULT_DEVICE,
    ].includes(type)
  ) {
    console.log("IM被踢");
    store.dispatch(
      countdownForRefresh({
        title: "您的账号已在另一设备上登录，请确认重新登录。",
        cb: () => history.replace("/chat"),
      })
    );
  } else if (type === TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED) {
    console.log("IM签名过期");
    store.dispatch(
      countdownForRefresh({
        title: "您的IM登录状态已过期，请重新登录。",
      })
    );
  }
}

function IMErrorHandler(event: any) {
  console.log("IM 未知错误");
  const errorCode = get(event, "data.code", "");
  const errorMessage = get(
    event,
    "data.message",
    `发生未知错误，错误码：[${errorCode}]，请确认重新登录。`
  );
  store.dispatch(
    countdownForRefresh({
      title: errorMessage,
    })
  );
}

export const registerIMEvent = createAsyncThunk(
  "chat/registerIMEvent",
  (tim: any, thunkAPI) => {
    tim.on(TIM.EVENT.SDK_READY, IMReadyHandler);
    tim.on(TIM.EVENT.SDK_NOT_READY, IMNotReadyHandler);
    tim.on(TIM.EVENT.MESSAGE_RECEIVED, IMMessageReceivedHandler);
    tim.on(TIM.EVENT.MESSAGE_READ_BY_PEER, IMMessageReadHandler);
    tim.on(TIM.EVENT.KICKED_OUT, IMKickedOutHandler);
    tim.on(TIM.EVENT.ERROR, IMErrorHandler);
  }
);

export const initIM = createAsyncThunk(
  "chat/initIM",
  async (arg: any, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    const state = thunkAPI.getState() as RootState;
    if (state.chat.IMLoading || state.chat.IMReady || im) return;
    dispatch(setIMLoading(true));
    const res = await IMService.getUserSign();
    const SDKAppID = get(res, "result.app_id");
    const userSig = get(res, "result.signature");
    const userID = get(res, "result.user_id");
    if (!SDKAppID || !userSig || !userID) {
      dispatch(countdownForRefresh({ title: "IM初始化失败，重试。" }));
      return;
    }
    const _tim = TIM.create({ SDKAppID });
    im = _tim;
    const logLevel = process.env.NODE_ENV === "production" ? 1 : 4;
    im.setLogLevel(logLevel);
    await dispatch(registerIMEvent(im));
    await im.login({ userID, userSig });

    // const userId = getQueryString("userId");
    // const sign = GenerateUserSign(userId);
    // const options = {
    //   SDKAppID: get(config, "TIM_SDKAppID"),
    // };
    // const _tim = TIM.create(options);
    // im = _tim;
    // const logLevel = process.env.NODE_ENV === "production" ? 1 : 3;
    // im.setLogLevel(logLevel);
    // await dispatch(registerIMEvent(im));
    // await im.login({ userID: userId, userSig: sign.userSig });
  }
);

export const extractMessageCard = (msg: any) => {
  const msg_content = get(msg, "msg_content");
  const jsonStr = get(msg_content, "data");
  try {
    const data = JSON.parse(jsonStr);
    return data;
  } catch (e) {
    console.log("parse JSON　error: ", e);
    return null;
  }
};

export const sortMessageByHistory = createAsyncThunk(
  "chat/sortMessageByFrom",
  async ({ msgs = [] }: { msgs: any[] }, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    const state = thunkAPI.getState() as RootState;
    const conversation = mapConversation(state);
    const from_user_id = get(conversation, "from_user_id");

    msgs.forEach((msg) => {
      const msgFrom = get(msg, "from_account");
      const isFromSelf = msgFrom === from_user_id;
      const fromAvatar = get(msg, "from_avatar");
      const fromName = get(msg, "from_name");
      const msgBody = get(msg, "msg_body", []);
      const msgTime = get(msg, "msg_time_stamp", []);
      const formatHistoryTime = msgTime * 1000;
      const messageCards = msgBody
        .map(extractMessageCard)
        .filter((card: any) => get(card, section_list_key));

      const isRead = get(msg, "read");

      messageCards.forEach((card: any) => {
        if (!card) return;
        if (isFromSelf) {
          dispatch(
            flatMessages({
              result: card,
              from: MessageFrom.SELF,
              config: {
                time: formatHistoryTime,
                fromHistory: true,
                read: isRead,
              },
            })
          );
        } else {
          dispatch(
            flatMessages({
              result: card,
              from: MessageFrom.OTHERS,
              config: {
                time: formatHistoryTime,
                avatar: getFilePrefix(fromAvatar),
                name: fromName,
                fromHistory: true,
              },
            })
          );
        }
      });
    });
  }
);

export function isLoginMode() {
  return compose(
    (mode) => mode === ChatMode.LOGIN,
    (state: RootState) => mapChatMode(state)
  )(store.getState() as RootState);
}
export function isBotMode() {
  return compose(
    (mode) => mode === ChatMode.BOT,
    (state: RootState) => mapChatMode(state)
  )(store.getState() as RootState);
}
export function isIMMode() {
  return compose(
    (mode) => mode === ChatMode.IM,
    (state: RootState) => mapChatMode(state)
  )(store.getState() as RootState);
}

let IMNonOperationTimer: any;
function IMNonOperationCountdown(secounds: number, cb: () => void) {
  clearTimeout(IMNonOperationTimer);
  // console.log("IM 无操作提示倒计时，方便测试同学用, 剩余秒数：", secounds);
  if (secounds > 0) {
    IMNonOperationTimer = setTimeout(() => {
      IMNonOperationCountdown(secounds - 1, cb);
    }, 1000);
  } else {
    cb();
  }
}

export const nonOperationCountdown = createAsyncThunk(
  "chat/nonOperationCountdown",
  async (arg: any, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const dispatch = thunkAPI.dispatch;
    const conversation = mapConversation(state);
    const enable = get(conversation, "end_of_non_operation.enable");
    const time = get(conversation, "end_of_non_operation.time");
    const end_remind_msg = get(
      conversation,
      "end_of_non_operation.end_remind_msg"
    );

    if (enable && time && end_remind_msg) {
      const cancelHistoryListen = history.listen((location, action) => {
        if (!get(location, "pathname", "").includes("/im?task_id=")) {
          typeof cancelHistoryListen === "function" && cancelHistoryListen();
          dispatch(cleanIM({}));
        }
      });

      IMNonOperationCountdown(time, () => {
        isIMMode() && dispatch(pushSystemMessage({ payload: end_remind_msg }));
      });
    }
  }
);

export const getIMHomePage = createAsyncThunk(
  "chat/getIMHomePage",
  async (arg: any, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    const task_id = getQueryString("task_id");
    if (!task_id) {
      history.replace("/chat");
      dispatch(setIMReady(false));
      dispatch(setIMLoading(false));
      return;
    }
    const homepage = await IMService.getHomepage(task_id);
    const code = get(homepage, "code");
    const message = get(homepage, "message", "获取对话详情失败。");
    const result:any = get(homepage, "result");
    const ex_msgs = get(result, "ex_msgs", []);
    const msgs:any = get(result, "msgs");
    const finish = get(result, "finish");
    const success = code === StatusCode.success;
    if (success) {
      dispatch(setConversation(result));

      // deal with transfer message
      if (ex_msgs.length === 0 && msgs.length === 0) {
        dispatch(setMessages([generateTimeMessage()]));
      }
      ex_msgs.forEach((msgArr: any[]) => {
        dispatch(sortMessageByHistory({ msgs: msgArr }));
        const aName = get(msgArr, "[0].from_name");
        const bName = get(msgArr, "[0].to_name");
        dispatch(
          pushSystemMessage({
            payload: `以上为 ${aName} 和 ${bName} 的历史对话`,
          })
        );
      });

      // deal with history message
      dispatch(sortMessageByHistory({ msgs }));

      if (finish) {
        dispatch(setIMLoading(false));
        dispatch(setIMReady(true));
      } else {
        // deal with operation countdown message
        dispatch(nonOperationCountdown({}));

        await dispatch(initIM({}));
      }
    } else {
      Modal.error({
        title: message,
        onOk: () => {
          history.replace("/chat");
        },
        centered: true,
      });
      throw Error(message);
    }
  }
);

let initIMPageLoading = false;

export const initIMPage = createAsyncThunk(
  "chat/initIMPage",
  async (arg: any, thunkAPI) => {
    if (initIMPageLoading) return;
    initIMPageLoading = true;

    const dispatch = thunkAPI.dispatch;
    dispatch(cleanIM({}));
    dispatch(setChatMode(ChatMode.IM));
    dispatch(setMessages([]));

    await Promise.all([
      dispatch(getBot({})),
      dispatch(getUserInfo({})),
      dispatch(getIMHomePage({})),
    ]);

    initIMPageLoading = false;
  }
);

export const setLastOneMessage = createAsyncThunk(
  'chat/setLastOneMessage',
  (
    {
      result,
      from = MessageFrom.BOT,
      config,
      index
    }: {
      result: any;
      from?: MessageFrom;
      config?: Partial<ClientMessage>;
      index: number;
    },
    thunkAPI
  ) => {
    const dispatch = thunkAPI.dispatch;
    const isObject =
      Object.prototype.toString
        .call(result)
        .match(/\s(\w*)]$/)?.[1]
        ?.toLowerCase() === 'object';

    if (isObject) {
      for (let k of Object.keys(result)) {
        const list = get(result, `[${k}]`);
        if (k === im_button_list_key) {
          dispatch(setConversation({ buttons: list }));
        } else if (k === section_list_key) {
          for (let n of list) {
            const page = get(n, 'page');
            page && dispatch(mapPageAction(page));

            const messages = get(n, 'card_list') as ServerMessage;
            if (Array.isArray(messages) && messages.length > 0) {
              const fromHistory = get(config, 'fromHistory');
              const withTimeMessages = withTimestamp(messages);
              const rawMessages = (fromHistory
                ? messages
                : withTimeMessages) as any;
              if (from === MessageFrom.SELF) {
                dispatch(pushSelfMessage({ payload: rawMessages, ...config }));
              } else if (from === MessageFrom.BOT) {
                dispatch(
                  setLastBotMessage({ payload: rawMessages, ...config } as any)
                );
              } else if (from === MessageFrom.OTHERS) {
                dispatch(
                  setLastBotMessage({ payload: rawMessages, ...config })
                );
              } else {
                dispatch(
                  setLastBotMessage({ payload: rawMessages, ...config })
                );
              }
            }
          }
        } else if (k === im_notice_list_key) {
          dispatch(pushSystemMessage({ payload: list }));
        } else if (k === im_event_list_key) {
          dispatch(IMEventHandler({ events: list }));
        }
      }
    }
  }
);